module.exports = __webpack_public_path__ + "static/media/default_profile.3ea3a19e.png";